import React from 'react';
import logo from '../assets/logo.png'

import { FaSquareXTwitter, FaYoutube, FaLinkedin } from "react-icons/fa6";
import { FaDiscord } from "react-icons/fa";
import { BiLogoTelegram, BiLogoGmail } from "react-icons/bi";



const Footer = () => {
    return (
        <footer className=" text-white bg-white bg-opacity-5 backdrop-blur-lg py-2 mt-20 w-[100%]">
            <div className="items-center">
                <div className="flex justify-center">
                    <img src={logo} alt="Website Logo" className="w-[160px] mr-3" />
                </div>


            </div>
            <div className="border-t container mx-auto py-3">
                <div className='flex justify-center'>
                    <a href="https://x.com/hussainzulz" target='_blank' className='mx-2'><FaSquareXTwitter /></a>
                
                    <a href="https://t.me/hussainzulz" target='_blank' className='mx-2' ><BiLogoTelegram /></a>
                    
                    <a href="https://www.linkedin.com/company/zelfilabs" target='_blank' className='mx-2' ><FaLinkedin /></a>
                    <a
                        href="https://mail.google.com/mail/?view=cm&fs=1&to=hussain@zelfilabs.com"
                        target="_blank"
                        className="mx-2">
                        <BiLogoGmail />
                    </a>



                </div>

            </div>
        </footer>
    );
};

export default Footer;





{/* <footer className=" text-white bg-white bg-opacity-5 backdrop-blur-lg py-2 mt-20 w-[100%]">
<div className="container mx-auto flex justify-between items-center">
    <div className="flex">
        <img src={logo} alt="Website Logo" className="h-20 mr-3" />

    </div>

    
    <div className="flex text-right items-center text-sm mb-10">
        <div className="flex flex-col  space-x-4 mb-2 mr-10">
            <a href="#" className="hover:underline m-1">Airdrop</a>
            <a href="#" className="hover:underline m-1">Our Partners</a>
            <a href="#" className="hover:underline m-1">Litepaper </a>
        </div>
        <div className="flex flex-col space-x-4 mb-2 mr-10">

            <a href="#" className="hover:underline m-1 mt-4">Blog</a>
            <a href="#" className="hover:underline m-1">News</a>
            <a href="#" className="hover:underline m-1">Contact Us</a>
            <a href="#" className="hover:underline m-1">Media Kit</a>
        </div>

    </div>
</div>
<div className="border-t container mx-auto py-1 flex justify-between items-center">
    <div className='flex'>
        <a href="#" className='mx-2'><FaSquareXTwitter /></a>
        <a href="#" className='mx-2' ><FaDiscord /></a>
        <a href="#" className='mx-2' ><BiLogoTelegram /></a>
        <a href="#" className='mx-2' ><FaYoutube /></a>
        <a href="#" className='mx-2' ><FaLinkedin /></a>


    </div>
    <div className='p-1 text-sm'>
        2024 All Rights Reserved By Zelfi
    </div>
</div>
</footer> */}